





























import {
  defineComponent,
} from 'vue-demi';
import { NativeMaterialInfo, NativeMaterialStatus } from './../../enums/media';

const name = 'ErrorHint';
export default defineComponent({
  name,
  components: {},
  props: {
    showHint: {
      type: Boolean,
      default: false,
    },
    hintMessage: {
      type: String,
      default: ''
    }
  },
  setup(_, { emit }) {
    const closeHint = () => {
      emit('close-hint');
    };
    return {
      closeHint
    };
  }
});
